import { Capacitor } from "@capacitor/core";
import { Filesystem } from "@capacitor/filesystem";

/**
 * Result from reading a file.
 */
export interface ReadFileResult {
  data: string | Blob;
}

/**
 * Reads a file from the given path.
 * On native platforms, reads the file contents.
 * On web, throws an error as this operation is not supported.
 *
 * @param path - The path to the file (typically a URI from file picker)
 * @returns The file contents as base64 string or Blob
 */
export async function readFile(path: string): Promise<ReadFileResult> {
  if (!Capacitor.isNativePlatform()) {
    throw new Error("readFile is only available on native platforms");
  }

  return await Filesystem.readFile({ path });
}
